import React from 'react';
import {Link} from 'react-router-dom';
import './Body.css';
import ServicesOverview from './ServicesOverview';
import Pillars from './Pillars';
import Reviews from './Reviews';

const ProcessSection = () => (
  <section className="process" aria-labelledby="ablauf-anfrage">
    <div className="process-inner">
      <div className="process-head">
        <p className="kicker">Einfacher Start</p>
        <h2 id="ablauf-anfrage" className="process-title">So läuft eine Anfrage bei uns ab</h2>
      </div>

      <ol className="process-grid">
        <li className="process-card">
          <span className="process-step" aria-hidden="true">1</span>
          <h3>Anrufen oder schreiben</h3>
          <p>Sie erreichen uns telefonisch oder über das Kontaktformular mit Ihrem Anliegen.</p>
        </li>
        <li className="process-card">
          <span className="process-step" aria-hidden="true">2</span>
          <h3>Persönlich besprechen</h3>
          <p>Wir klären gemeinsam, welche Unterstützung gebraucht wird und welche Leistungen passen.</p>
        </li>
        <li className="process-card">
          <span className="process-step" aria-hidden="true">3</span>
          <h3>Versorgung planen</h3>
          <p>Danach stimmen wir die nächsten Schritte für die Versorgung in Eitorf und Umgebung mit Ihnen ab. Anträge und Abrechnung übernehmen wir.</p>
        </li>
      </ol>

      <div className="process-actions">
        <Link className="btn btn--primary" to="/kontakt">Kostenlos beraten lassen</Link>
        <Link className="btn btn--ghost" to="/faq">Häufige Fragen</Link>
      </div>
    </div>
  </section>
);

const Body = () => (
  <main className="home" id="inhalt">
    <ServicesOverview />
    <Pillars />
    <ProcessSection />
    <Reviews />
  </main>
);

export default Body;
